import { render, staticRenderFns } from "./AppMediaPopupPhotoInfo.vue?vue&type=template&id=4f690d8c&scoped=true"
import script from "./AppMediaPopupPhotoInfo.vue?vue&type=script&lang=ts"
export * from "./AppMediaPopupPhotoInfo.vue?vue&type=script&lang=ts"
import style0 from "./AppMediaPopupPhotoInfo.vue?vue&type=style&index=0&id=4f690d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f690d8c",
  null
  
)

export default component.exports